import { memo } from 'react'
import Icon from '~components/ui/icon'
import { cn } from '~utils/cn'

interface SuccessProps {
  title: string
  appName: string
  appLink?: string
}
const SamsungSmartThingsAuthSuccess = memo(({ title, appName, appLink }: SuccessProps) => {
  return (
    <main className="flex flex-1 flex-col items-center justify-center bg-background h-full">
      <div className="flex flex-col items-center flex-gap-y-4 p-4 pt-6 h-[444px] w-full justify-center">
        <Icon name="check_circle_solid" className="size-16 fill-green-500" />
        <h1 className="text-gray-900 text-headline-3">{title}</h1>
        <p
          className={cn('whitespace-pre-line text-center text-gray-700 text-body-2')}
          onClick={() => {
            if (appLink) {
              window.open(appLink, '_blank')
            }
          }}
        >
          <span>{`Your account is now connected.\nPlease return to the `}</span>
          <span className={cn('text-secondary-500 cursor-pointer', appLink && 'underline')}>
            {appName} app
          </span>
          <span>{` to continue.`}</span>
        </p>
      </div>
    </main>
  )
})

SamsungSmartThingsAuthSuccess.displayName = 'SamsungSmartThingsAuthSuccess'

export default SamsungSmartThingsAuthSuccess
